import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Delete Confirmation|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesDeleteConfirmation';
export type SPSettingsRolesDeleteConfirmationLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}ContentConfirmDelete`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`;

export const spSettingsRolesDeleteConfirmationLocs: LocDefs<SPSettingsRolesDeleteConfirmationLocNames> =
	{
		SPSettingsRolesDeleteConfirmationTitle: {
			defaultValue: 'Please Confirm',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Core/Settings.Roles.Title.ConfirmDelete',
			...sharedProperties,
		},
		SPSettingsRolesDeleteConfirmationContentConfirmDelete: {
			defaultValue:
				'Permanently remove this role from the system? This action cannot be undone.',
			description: 'Text to confirm deletion of a role',
			displayPath: `${pathStart}Delete confirmation text`,
			displayType: 'Content',
			legacyName: 'Core/Settings.Roles.Content.ConfirmDelete',
			...sharedProperties,
		},
		SPSettingsRolesDeleteConfirmationButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Core/Settings.Roles.Button.ConfirmDeleteCancel',
			...sharedProperties,
		},
		SPSettingsRolesDeleteConfirmationButtonSave: {
			defaultValue: 'Delete Role',
			description: 'Delete Role button',
			displayPath: `${pathStart}Delete Role`,
			displayType: 'Button',
			legacyName: 'Core/Settings.Roles.Button.ConfirmDeleteSave',
			...sharedProperties,
		},
	};

export type SPSettingsRolesDeleteConfirmationLocType =
	LocMap<SPSettingsRolesDeleteConfirmationLocNames>;
